const axios = require('axios');
const API_URL = process.env.CLAIM_ACTIVITY_API;
const SYNC_API_URL = process.env.CLAIM_ACTIVITY_SYNC_API;
const SYNC_API_KEY = process.env.CLAIM_ACTIVITY_SYNC_KEY;

const runClaimSyncHandler = async () => {
    const response = await axios.post(`${API_URL}api/batch/runClaimSyncHandler`, {});
    if (response.status !== 200) {
        return null;
    }

    return response.data;
}

/**
 * @param {string} memberUuid 
 * @param {json} startKey
 */
const getClaimsPageByMember = async (memberUuid, startKey = null) => {
    let key = '';
    if (startKey) {
        key = `?startKey=${Buffer.from(JSON.stringify(startKey)).toString('base64')}`;
    }
    const response = await axios.get(`${API_URL}query/claimsByMember/${memberUuid}${key}`);
    if (response.status !== 200) {
        return null;
    }

    return response.data;
}

/**
 * @param {string} memberUuid 
 */
const getAllClaimsByMember = async (memberUuid) => {
    let claimsList = [];
    let claimsPage = await getClaimsPageByMember(memberUuid);
    claimsList.push(...claimsPage.Items);

    while (claimsPage.LastEvaluatedKey !== "") {
        let nextPage = await getClaimsPageByMember(memberUuid, claimsPage.LastEvaluatedKey);
        claimsList.push(...nextPage.Items);
    }
    return claimsList;
}

/**
 * @param {string} employeeCertificateNumber 
 */
const getClaimsPageByFamily = async (employeeCertificateNumber, startKey = null) => {
    let key = '';
    if (startKey) {
        key = `?startKey=${Buffer.from(JSON.stringify(startKey)).toString('base64')}`;
    }
    const response = await axios.get(`${API_URL}query/claimsByFamily/${employeeCertificateNumber}${key}`);
    if (response.status !== 200) {
        return null;
    }

    return response.data;
}

/**
 * @param {string} employeeCertificateNumber 
 */
const getAllClaimsByFamily = async (employeeCertificateNumber) => {
    let claimsList = [];
    let claimsPage = await getClaimsPageByFamily(employeeCertificateNumber);
    claimsList.push(...claimsPage.Items);

    while (claimsPage.LastEvaluatedKey !== "") {
        let nextPage = await getClaimsPageByFamily(employeeCertificateNumber, claimsPage.LastEvaluatedKey);
        claimsList.push(...nextPage.Items);
    }
    return claimsList;
}

/**
 * @param {string} claimNumber 
 */
const getClaimByClaimNumber = async (claimNumber) => {
    const response = await axios.get(`${API_URL}query/claimByClaimNumber/${claimNumber}`);

    if (response.status !== 200) {
        return null;
    }

    return response.data;
}



/**
 * @param {string} family 
 */
const syncFamilyClaimList = async (employeeCertificateNumber, memberUuid) => {
    const body = {
        subscriberFamilyIdentifier: employeeCertificateNumber,
        memberUuid: memberUuid
    };
    const response = await axios.post(`${API_URL}commands/batchSync/family`, body);

    if (response.status !== 200) {
        return null;
    }

    return response;
}

/**
 * 
 * @param {string} memberUuid 
 * @param {string} source
 */
const syncAllMemberClaims = async (memberUuid, source) => {
    try {
        const body = {
            memberUuid,
            source
        };

        const response = await axios.post(`${SYNC_API_URL}claims/syncAllMemberClaims`, JSON.stringify(body), {
            headers: {
                'Authorization': SYNC_API_KEY,
                'Content-Type': 'application/json'
            },
            body
        });

        return response;
    }
    catch (e) {
        throw e.response;
    }
}

/**
 * 
 * @param {string} memberUuid
 */
const getSyncStatus = async (memberUuid) => {
    try {
        const response = await axios.get(`${SYNC_API_URL}claims/getSyncStatus`, {
            headers: {
                'Authorization': SYNC_API_KEY,
                'Content-Type': 'application/json'
            },
            params: {
                memberUuid: memberUuid
            }
        });

        return response;
    }
    catch (e) {
        throw e.response;
    }
}

module.exports = {
    getClaimsPageByMember,
    getAllClaimsByMember,
    getClaimsPageByFamily,
    getAllClaimsByFamily,
    getClaimByClaimNumber,
    syncFamilyClaimList,
    syncAllMemberClaims,
    getSyncStatus,
    runClaimSyncHandler
}